import $ from 'jquery';
import 'underscore';

import Backbone from 'backbone';
import MoodhackerController from 'controllers/moodhacker';
import NativeView from 'views/native';


if (window.mobile) {
  window.app = new NativeView({ el: $('body') });
  window.app.render();
}
new MoodhackerController({ mobile: window.mobile });
Backbone.history.start({ pushState: true });



// WEBPACK FOOTER //
// ./static/js/init.js